import React, {useEffect} from 'react';
import {Box, styled} from '@mui/material';
import Page from '@/components/page';
import GigsCollectionView from './GigsCollectionView';
import MyInvitesSectionView from './MyInvitesSectionView';
import {media} from '@/styles/mediaQueries';
import LEGACY_COLORS from '@/styles/legacyColors';
import useTrackScreenEvent from '@/hooks/analytics/use-track-screen-event';
import {screenNames} from '@/lib/delta/deltaConstants';

const StyledMobileSpacer = styled(Box)(() => ({
  display: 'none',
  [media.mobile]: {
    display: 'block',
    height: '7px',
    width: '100vw',
    marginLeft: 'calc(-50vw + 50%)',
    marginRight: 'calc(-50vw + 50%)',
    backgroundColor: LEGACY_COLORS.GRAY_LIGHTEST,
  },
}));

function GigsCollectionPage() {
  const {presented, dismissed} = useTrackScreenEvent();

  useEffect(() => {
    presented({
      screen_name: screenNames.suggested_gigs.suggested_gigs,
      source: '',
    });
    return () => {
      dismissed({
        screen_name: screenNames.suggested_gigs.suggested_gigs,
        destination: '',
      });
    };
  }, [presented, dismissed]);

  return (
    <Page constrained>
      <MyInvitesSectionView />
      <StyledMobileSpacer />
      <GigsCollectionView />
    </Page>
  );
}

export default GigsCollectionPage;
